module.exports = __webpack_public_path__ + "static/img/Four of Swords.7d2858e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Four of Swords.jpg
// module id = 1272
// module chunks = 0